import { memo, useMemo } from 'react';
import { GameLeaderboardTableProps } from '../props';
import GameLeaderboardTableRow from './Row';
import styles from './styles.module.scss';
import { useInfiniteScroll } from '@starsoft/common/hooks';

function GameLeaderboardTableBody({
  scoreboard,
  isLoading,
  fetchNextPage,
  hasNextPage,
  isFetchingNextPage,
  shouldShowResult,
  shouldShowReducedInfo,
  smallerHeight,
}: GameLeaderboardTableProps) {
  const Rows = useMemo(
    () =>
      scoreboard?.map(bet => (
        <GameLeaderboardTableRow
          key={`crash_leaderboard_row_${bet?.id}`}
          bet={bet}
          shouldShowResult={shouldShowResult}
          shouldShowReducedInfo={shouldShowReducedInfo}
        />
      )),
    [scoreboard, shouldShowResult, shouldShowReducedInfo],
  );

  const Skeleton = useMemo(
    () =>
      Array.from({ length: 10 })?.map((_, i) => (
        <GameLeaderboardTableRow
          key={`crash_leaderboard_row_skeleton_${i}`}
          bet={null}
          isLoading
          shouldShowReducedInfo={shouldShowReducedInfo}
        />
      )),
    [shouldShowReducedInfo],
  );

  const { ref } = useInfiniteScroll({
    hasMore: hasNextPage ?? false,
    isLoading: (isLoading || isFetchingNextPage) ?? false,
    loadMore: fetchNextPage,
  });

  return (
    <tbody
      className={`${styles.container} ${smallerHeight ? styles['container--small'] : ''}`}
      ref={ref}
    >
      {isLoading ? Skeleton : Rows}
      {isFetchingNextPage && Skeleton}
    </tbody>
  );
}

export default memo(GameLeaderboardTableBody);
